import React, { useContext } from 'react'
import { RichText } from 'prismic-reactjs'
import dynamic from 'next/dynamic'
import './Suggestions.scss'
import Link from './elements/link'
import GlobalContext from '../global'
const Image = dynamic(() => import('./elements/image'), { ssr: false, loading: () => null })

function Suggestions(props) {
  const global = useContext(GlobalContext)
  return (
    <section>
      <div className="article-suggestions">
        <h3>{global.data.suggestions_title}</h3>
        {props.related.map((related, i) => {
          if (!related.id) {
            return null
          }
          let bgImage
          if (related.data.teaser_image) {
            bgImage = related.data.teaser_image
          } else if (related.data.title_image) {
            bgImage = related.data.title_image
          }
          return (
            <Link key={`related-${related.id}`} type="internal" route={`/${related.uid}`}>
              <a className="suggestion">
                <Image className="related-image" forceProperty={'mobile'} image={bgImage}>
                  <div className="inner">
                    <div className="index">{i + 1}</div>
                    <h4>{RichText.asText(related.data.title)}</h4>
                    <div className="subline">{related.data.subline}</div>
                  </div>
                </Image>
              </a>
            </Link>
          )
        })}
      </div>
    </section>
  )
}

export default Suggestions
